/**
 * Intercom configuration constants.
 */

export const INTERCOM_APP_ID = process.env.NEXT_PUBLIC_INTERCOM_APP_ID ?? 'j8v9i2vs';
export const USE_INTERCOM = process.env.NEXT_PUBLIC_USE_INTERCOM === 'true';
